module.exports = __webpack_public_path__ + "assets/4ba9f659d724922731bbdad6761a595f.mp3";


/*****************
 ** WEBPACK FOOTER
 ** ./public-src/sounds/buttons/denoms/denom-10.mp3
 ** module id = 223
 ** module chunks = 0
 **/